import { Tracker } from '@studyportals/datalake-event-tracker';

export default class DataLakeEventTracker extends Tracker {
	public get isTrackingFunctionalityAvailable(): boolean {
		// The type of the tracker is handled inside the package, which we don't have control over, so disable linting here.
		// eslint-disable-next-line
		return this.tracker && this.tracker.tracker !== null;
	}
}
